import React, { useEffect } from "react";
import {
  getDocData,
  getAllDocs,
  setDocData,
} from "../../../utils/firebase/Firebase.utils";
import InputBox from "../../Dashboard/Components/InputBox";
import toast from "react-hot-toast";
import blankPhoto from "../../assets/blankgroupphoto.avif";
import { storage } from "../../../utils/firebase/Firebase.utils";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { useSelector } from "react-redux";

export default function AddParticpantForm({
  groupChat,
  handleAddParticipants,
  id,
}) {
  const { members, admins = [] } = groupChat;
  const currentUser = useSelector((state) => state.userObject);
  const [users, setUsers] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [participants, setParticipants] = React.useState(members);
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [adminsList, setAdminsList] = React.useState(admins);
  const [image, setImage] = React.useState("");
  const [uploading, setUploading] = React.useState(false);
  const [progress, setProgress] = React.useState(0);

  useEffect(() => {
    const fetchAllUsers = async () => {
      const users = await getAllDocs("users");
      setUsers(users);
      setIsLoading(false);
    };
    fetchAllUsers();
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-[#8FCD00]"></div>
      </div>
    );
  }

  const membersMap = users.filter((user) => participants.includes(user.id));

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const options = users.map((user) => ({
    value: user.id,
    label: user.displayName,
  }));

  const filteredUsers = users.filter((user) =>
    user.displayName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleAdd = (user) => {
    //check if user is already in the group
    if (participants.includes(user.id)) {
      toast.error("User is already in the group");
      return;
    }

    setParticipants([...participants, user.id]);
    setSearchTerm("");
  };

  const handleSave = async () => {
    setIsProcessing(true);
    await setDocData("groupChats", id, {
      members: participants,
      admins: adminsList,
    });
    handleAddParticipants();
    setIsProcessing(false);
    toast.success("Group Settings updated successfully");
  };

  const handleRemove = (user) => {
    if (
      window.confirm(`Are you sure you want to remove ${user.displayName}?`)
    ) {
      const updatedParticipants = participants.filter(
        (participant) => participant !== user.id
      );
      setParticipants(updatedParticipants);
    }
  };

  const handleAddRemoveAdmin = (user) => {
    if (adminsList.includes(user.id)) {
      const updatedAdmins = adminsList.filter((admin) => admin !== user.id);
      setAdminsList(updatedAdmins);
    } else {
      setAdminsList([...adminsList, user.id]);
    }
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    const storageRef = ref(storage, `groupChatImages/id/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        setUploading(true);
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(progress);
        switch (snapshot.state) {
          case "paused":
            break;
          case "running":
            break;
          default:
            break;
        }
      },
      (error) => {
        setUploading(false);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          await setDocData("groupChats", id, { image: downloadURL });
          setUploading(false);
          toast.success("Image uploaded successfully");
        });
      }
    );
  };

  return (
    <div className="w-full max-w-md mx-auto bg-white rounded-lg shadow-md p-3 relative overflow-y-auto max-h-[90vh] md:max-h-[80vh]">
      <div className="flex items-center justify-between mb-2 border-b border-gray-100 pb-2">
        <h2 className="text-base font-semibold text-[#363062]">
          Add Participants
        </h2>
        <button
          onClick={handleAddParticipants}
          className="text-[#363062] hover:text-[#8FCD00] transition-colors"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <div className="mb-2">
        <div className="relative">
          <input
            className="w-full px-3 py-1.5 text-xs rounded-lg border border-gray-200 focus:outline-none focus:ring-1 focus:ring-[#8FCD00] focus:border-transparent"
            placeholder="Search for users..."
            type="search"
            onChange={handleSearch}
            value={searchTerm}
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-3.5 w-3.5 absolute right-2.5 top-2 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>

        {searchTerm.length > 0 && (
          <div className="absolute z-10 mt-0.5 w-[calc(100%-2rem)] bg-white rounded-lg shadow-lg max-h-32 overflow-y-auto">
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <div
                  key={user.id}
                  onClick={() => handleAdd(user)}
                  className="px-2 py-1.5 hover:bg-gray-50 cursor-pointer transition-colors flex items-center"
                >
                  <div className="w-5 h-5 rounded-full bg-[#363062] text-white flex items-center justify-center text-[10px] mr-1.5">
                    {user.displayName.charAt(0).toUpperCase()}
                  </div>
                  <div className="text-xs">{user.displayName}</div>
                </div>
              ))
            ) : (
              <div className="px-2 py-1.5 text-gray-500 text-xs">
                No users found
              </div>
            )}
          </div>
        )}
      </div>

      <div className="mb-3">
        <h3 className="text-xs font-medium text-[#363062] mb-1">
          Current Members
        </h3>
        <div className="bg-gray-50 rounded-lg p-1.5 max-h-[30vh] overflow-y-auto">
          {membersMap.length > 0 ? (
            membersMap.map((participant, index) => (
              <div
                key={index}
                className="flex items-center justify-between py-1 px-1.5 rounded-md hover:bg-gray-100 transition-colors"
              >
                <div className="flex items-center">
                  <div className="w-5 h-5 rounded-full bg-[#363062] text-white flex items-center justify-center text-[10px] mr-1.5">
                    {participant.displayName.charAt(0).toUpperCase()}
                  </div>
                  <div className="text-xs">
                    <div className="font-medium">{participant.displayName}</div>
                    <div className="text-[10px] text-gray-500">
                      {adminsList.includes(participant.id) ? "Admin" : "Member"}
                    </div>
                  </div>
                </div>

                {admins.includes(currentUser.uid) && (
                  <div className="flex gap-1">
                    <button
                      className="text-[10px] px-1.5 py-0.5 rounded-md bg-gray-200 hover:bg-[#363062] hover:text-white transition-colors"
                      onClick={() => handleAddRemoveAdmin(participant)}
                    >
                      {adminsList.includes(participant.id)
                        ? "Remove Admin"
                        : "Make Admin"}
                    </button>
                    <button
                      onClick={() => handleRemove(participant)}
                      className="text-[10px] px-1.5 py-0.5 rounded-md bg-gray-200 hover:bg-red-500 hover:text-white transition-colors"
                    >
                      Remove
                    </button>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="text-center py-2 text-gray-500 text-xs">
              No members added yet
            </div>
          )}
        </div>
      </div>

      <div className="mb-4">
        <h3 className="text-xs font-medium text-[#363062] mb-1">Group Image</h3>
        <div className="flex items-center gap-2">
          <div className="relative group">
            <img
              className="w-12 h-12 rounded-full object-cover border-2 border-[#8FCD00]"
              src={groupChat.image || blankPhoto}
              alt="Group"
            />
            {uploading && (
              <div className="absolute inset-0 flex items-center justify-center rounded-full bg-black bg-opacity-50 text-white text-[10px]">
                {Math.round(progress)}%
              </div>
            )}
          </div>

          <div className="flex-1">
            <label className="inline-flex items-center px-2 py-1 bg-[#363062] text-white rounded-md cursor-pointer hover:bg-opacity-90 transition-colors text-xs">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-3 w-3 mr-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
              Upload Photo
              <input type="file" onChange={handleUpload} className="hidden" />
            </label>
            {uploading && (
              <div className="mt-1 w-full bg-gray-200 rounded-full h-1">
                <div
                  className="bg-[#8FCD00] h-1 rounded-full"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="mt-3 flex justify-end">
        <button
          disabled={isProcessing}
          onClick={handleSave}
          className="px-3 py-1.5 bg-[#8FCD00] text-white text-xs rounded-md hover:bg-opacity-90 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center"
        >
          {isProcessing ? (
            <>
              <svg
                className="animate-spin -ml-0.5 mr-1.5 h-3 w-3 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              Saving...
            </>
          ) : (
            "Save Changes"
          )}
        </button>
      </div>
    </div>
  );
}